import { createSlice } from '@reduxjs/toolkit';
import {
  scheduleMessage,
  setTempScheduleMessage,
  getScheduledMessage,
  resetScheduleMessage,
} from '../actions';

export const initialState = {
  scheduleMessage: {},
  scheduleMessageUpdated: false,
  scheduleMessageFetched: false,
  tempScheduleMessage: {},
};

const scheduleMessageSlice = createSlice({
  name: 'scheduleMessage',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(scheduleMessage.pending, (state) => {
      state.scheduleMessageUpdated = false;
    });

    builder.addCase(scheduleMessage.fulfilled, (state, action) => {
      const { scheduledMessage, sendNow } = action.payload;
      const { sendTo } = action.meta.arg;

      state.scheduleMessageUpdated = true;
      state.scheduleMessage = { ...scheduledMessage, sendToList: sendTo };
      state.sendNow = sendNow;
    });

    builder.addCase(scheduleMessage.rejected, (state, action) => {
      state.scheduleMessageUpdated = false;
      state.error = action.payload.error;
    });

    builder.addCase(setTempScheduleMessage, (state, action) => {
      state.tempScheduleMessage = action.payload;
    });

    builder.addCase(getScheduledMessage.fulfilled, (state, action) => {
      const { schedule } = action.payload;

      state.scheduleMessage = schedule;
      state.scheduleMessageFetched = true;
    });

    builder.addCase(getScheduledMessage.rejected, (state, action) => {
      state.scheduleMessageFetched = false;
      state.error = action.payload.error;
    });

    builder.addCase(resetScheduleMessage, (state) => {
      state.scheduleMessage = {};
      state.scheduleMessageUpdated = false;
      state.scheduleMessageFetched = false;
    });
  },
});

export default scheduleMessageSlice;
